import Markdown from 'markdown-to-jsx'
import { forwardRef } from 'react'
import dayjs from 'src/utils/dayjs'
import type { NewsArticleDataType } from './util'

export default forwardRef<
  HTMLDivElement,
  StyleProps & { updatedAt: string; articleData: NewsArticleDataType }
>(function NewsArticle({ updatedAt, articleData, className, style }, ref) {
  const updatedTime = dayjs(updatedAt)
  const { title, content } = articleData

  return (
    <article ref={ref} className={className} style={style}>
      <h1 className="text-2xl font-medium text-center text-balance">{title}</h1>
      <p className="mt-4 text-center">
        <time
          dateTime={updatedTime.toISOString()}
          className="text-sm text-neutral-500"
        >
          {updatedTime.format('lll')}
        </time>
      </p>
      <Markdown className="mt-8 mx-auto prose dark:prose-invert">
        {content || ''}
      </Markdown>
    </article>
  )
})
